<template>
  <div>
    <div class="seth-set bg-primary">
      <div class="absolute top-0 py-10 w-full px-6">
        <p
          class="gap-2 cursor-pointer fsize14 mb-1 text-white flex items-center font-medium"
          @click="handleBack"
        >
          <feather-icon
            class="flex"
            icon="ArrowLeftIcon"
            svgClasses="w-6 h-6"
          />
          Go Back
        </p>
        <h2 class="text-white pt-1 text-2xl capitalize font-semibold">
          Contact Us
        </h2>
      </div>
    </div>

    <div class="bg-white fixed-top p-8 flex justify-center items-center">
      <div class="text-center w-full mx-auto">
        <!-- <el-Input
          placeholder=""
          v-model="input"
          class="w-full"
          type="text"
          
        /> -->
        <div class="bg-white relative flex items-center w-full mx-auto mt-4">
          <div class="relative pr-4 w-full">
            <el-input
              placeholder="Search"
              v-model="inputSearch"
              class="w-full"
              maxlength="50"
              @input="getData"
            ></el-input>
            <div
              class="absolute top-0 mr-2 mt-2 bg-white cursor-pointer right-16px"
            >
              <feather-icon icon="SearchIcon" SvgClasses="w-4 h-4" />
            </div>
          </div>
          <el-button
            @click="emailPopup = true"
            type="primary"
            icon="el-icon-s-tools"
            class="rounded-lg cust-elprimary"
          ></el-button>
        </div>

        <el-dialog
          class="cust-header"
          width="30%"
          title="Email Configuration"
          :visible.sync="emailPopup"
        >
          <div class="w-full mx-auto">
            <el-input
              :disabled="emailInputDisable"
              placeholder="Email Id"
              type="email"
              maxlength="50"
              v-validate="'required'"
              v-model="email"
            ></el-input>
            <p class="col-4f text-sm mt-4 font-semibold">
              Add your email id to get updates on your email whenever anyone
              fills the contact us form on your website
            </p>

            <vs-button
              :disabled="emailInputDisable"
              @click="setConfigEmail"
              type="success"
              class="bg-success rounded-lg mt-6 border-0 font-semibold lg:py-3 fsize14 md:py-3 py-2 px-10 sm-fsize14"
            >
              Save
            </vs-button>
          </div>
        </el-dialog>
        <div class="w-full mb-8">
          <el-table
            :data="contactUsData"
            border
            style="width: 100%"
            class="table-responsive table-flush mt-6 cust-overflow-x-primary-color"
            header-row-class-name="thead-light table-th-colorpd"
          >
            <el-table-column
              :index="indexmethod"
              type="index"
              label="Sr.no"
              width="80"
            ></el-table-column>
            <el-table-column prop="name" label="Name"> </el-table-column>
            <el-table-column prop="email" label="Email"> </el-table-column>
            <el-table-column prop="mobile" label="Mobile"> </el-table-column>
            <el-table-column
              prop="description"
              label="Description"
            ></el-table-column>

            <el-table-column
              prop="createdAt"
              label="Date"
              :formatter="getDate"
            ></el-table-column>
            <el-table-column
              prop="opted"
              label="Newsletter"
              :formatter="opted"
            ></el-table-column>
          </el-table>
          <div class="w-full flex justify-end mt-6">
            <el-pagination
              background
              layout="prev, pager, next"
              @current-change="
                (value) => {
                  currentPage = value;
                  getData();
                }
              "
              :page-size="10"
              :total="count"
            >
            </el-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import moment from "moment";
import { mapState } from "vuex";
export default {
  data() {
    return {
      email: "",
      contactUsData: [],
      inputSearch: "",
      currentPage: 1,
      emailPopup: false,
      // for disable input and button once upload email
      emailInputDisable: false,
      count: 1,
    };
  },
  methods: {
    getDate(createdAt) {
      return moment(createdAt).format("MMMM Do YYYY");
    },
    // opted(value) {
    //   if (value) {
    //     return "Opteds";
    //   } else {
    //     return "not";
    //   }
    // },
    opted(row, column, cellValue) {
      console.log(row);
      return cellValue ? "Opted" : "Not Opted";
    },

    // on this email data of contactus will be send which is coming from website
    async setConfigEmail() {
      if (this.email.trim().length == 0) {
        this.$swal("", "Please input valid Email.", "info");
      } else {
        let payload = {
          projectName: this.selectedProject.projectName,
          projectId: this.selectedProject._id,
          contactDetails: true,
          contactUsEmail: this.email,
        };
        let data = await this.$store.dispatch(
          "brandProfile/uploadBrandProfile",
          payload
        );
        this.emailPopup = false;
        this.$swal("", "You Email is saved Successfully.", "success");
        this.emailPopup = false;
      }
    },
    async getData() {
      let payload = {
        limit: 10,
        pagination: true,
      };
      if (this.inputSearch != "") {
        Object.assign(payload, { search: this.inputSearch });
      }
      Object.assign(payload, { offset: this.currentPage * 10 - 10 });

      const data = await this.$store.dispatch("admin/contactUsData", payload);
      this.contactUsData = data.data.data.data.data;
      this.count = data.data.data.data.count;
      console.log(this.contactUsData);
    },
    indexmethod(index) {
      if (this.currentPage > 1) {
        let value = (this.currentPage - 1) * 10;
        return index + value + 1;
      } else {
        return index + 1;
      }
    },
    disableEmail() {
      // for disable input and button once upload email

      if (this.brandProfile.contactDetails.contactUsEmail) {
        this.email = this.brandProfile.contactDetails.contactUsEmail;
        this.emailInputDisable = true;
      }
    },
  },
  async mounted() {
    await this.getData();
    this.disableEmail();
  },
  computed: {
    ...mapState("user", ["selectedProject"]),
    ...mapState("brandProfile", ["brandProfile"]),
  },
};
</script>
